module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$route.name === 'CustomFields') ? _c('div', [_c('admin-filter', {
    model: {
      value: (_vm.filterParams),
      callback: function($$v) {
        _vm.filterParams = $$v
      },
      expression: "filterParams"
    }
  }), _vm._v(" "), _c('admin-card', [_c('template', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n      Список кастомных полей\n      "), _c('router-link', {
    staticClass: "pull-right btn btn-primary btn-sm",
    attrs: {
      "to": {
        name: 'CustomFieldsCreate'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Добавить\n      ")])], 1), _vm._v(" "), _c('admin-list', {
    attrs: {
      "items": _vm.items,
      "loading": _vm.loading
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "col-6 col-md-4"
        }, [_vm._v("\n            " + _vm._s(item.name) + "\n          ")]), _vm._v(" "), _c('div', {
          staticClass: "col-6 col-md-2"
        }, [_vm._v("\n            " + _vm._s(item.code) + "\n          ")]), _vm._v(" "), _c('div', {
          staticClass: "col-6 col-md-2"
        }, [_vm._v("\n            " + _vm._s(item.sort) + "\n          ")]), _vm._v(" "), _c('div', {
          staticClass: "col-6 col-md-3"
        }, [_c('router-link', {
          staticClass: "btn btn-primary btn-sm",
          attrs: {
            "to": {
              name: 'CustomFieldsEdit',
              params: {
                id: item.id
              }
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-edit"
        }), _vm._v(" Изменить\n            ")])], 1)]
      }
    }])
  }, [_c('template', {
    attrs: {
      "slot": "headerList"
    },
    slot: "headerList"
  }, [_c('div', {
    staticClass: "col-6 col-md-4"
  }, [_vm._v("Название")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-2"
  }, [_vm._v("Код")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-2"
  }, [_vm._v("Сортировка")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-3"
  }, [_vm._v("Управление")])])], 2), _vm._v(" "), _c('template', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('admin-pagination', {
    attrs: {
      "paginator": _vm.itemsPage.paginator
    },
    model: {
      value: (_vm.page),
      callback: function($$v) {
        _vm.page = $$v
      },
      expression: "page"
    }
  })], 1)], 2)], 1) : _c('router-view')
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-90d61a6a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/vue-loader/lib/template-compiler?{"id":"data-v-90d61a6a"}!/home/alarmplan/staging/shared/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Admin/CustomFields/CFList.vue
// module id = 1061
// module chunks = 1